import { useUserSession } from '@solinkcorp/authentication';
import { PlatformApi } from 'clients';

/** simple wrapper that instantiates PlatformApi with acces token from useUserSession instead of
 * deprecated AuthService.authToken
 */
function usePlatformClient() {
  const user = useUserSession();

  return PlatformApi(user.accessToken);
}

export default usePlatformClient;
